export default {
  en: 'English',
  de: 'German',
  fr: 'French',
};

export const flags = {
  en: 'flags/en.png',
  de: 'flags/de.png',
  fr: 'flags/fr.png',
};

export const databases = {
  de: 'll-wordbook-deutsch',
  fr: 'll-wordbook-francais',
};

export const translationLanguages = ['fr', 'de'];
